import React, { useRef, useEffect } from 'react';

//plans
export const plans = [
  {
    title: 'Basic',
    description: 'Perfect for getting started',
    price: '$0',
    priceId: 'price_1RlAZZFYj9GidIJrWLc3x5DH',
    features: [
      'Conversational AI that handles everyday questions with ease',
      'Personalized suggestions to help you discover relevant insights',
      'Full access to core chatbot functionality at no cost'
    ]
  },
  {
    title: 'Pro',
    description: 'For growing teams',
    price: '$20',
    priceId: 'price_1RlAYWFYj9GidIJrPgK15O04',
    features: [
      'Advanced AI with image recognition and contextual understanding',
      'Interactive analytics dashboard for conversation metrics',
      'Priority email support to resolve issues quickly'
    ]
  },
  {
    title: 'Enterprise',
    description: 'Advanced features & support',
    price: '$200',
    priceId: 'price_1RlAa3FYj9GidIJrBscks66Z',
    features: [
      'Multi-modal AI (voice, text & image) integration via API',
      'Configurable workflows tailored to your organization’s needs',
      'Dedicated account manager with fast response times'
    ]
  }
];

// gradient
export const GRADIENT =
  'conic-gradient(from 180deg at 50% 50%, #FF98E2 0deg, #FFC876 35.77deg, #79FFF7 153.75deg, #9F53FF 258.75deg, #FF98E2 360deg)';

export const gradientText = {
  bgImage: GRADIENT,
  bgClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent'
};

// stars
export function StarField({ width = 2000, height = 300, starCount = 900 }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const stars = Array.from({ length: starCount }).map(() => ({
      x: Math.random() * width,
      y: Math.random() * height,
      radius: Math.random() * 1.2 + 0.3,
      alpha: Math.random(),
      delta: (Math.random() * 0.015) + 0.005
    }));
    let animationId;

    const render = () => {
      ctx.clearRect(0, 0, width, height);
      stars.forEach(star => {
        star.alpha += star.delta;
        if (star.alpha <= 0 || star.alpha >= 1) star.delta = -star.delta;
        ctx.beginPath();
        ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255, ${star.alpha})`;
        ctx.fill();
      });
      animationId = requestAnimationFrame(render);
    };

    render();
    return () => cancelAnimationFrame(animationId);
  }, [width, height, starCount]);

  return (
    <canvas
      ref={canvasRef}
      width={width}
      height={height}
      style={{
        position: 'absolute',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 0,
        opacity: 0.6,
        pointerEvents: 'none'
      }}
    />
  );
}
